export const SET_SITE_THEME = 'SET_SITE_THEME'
export const SET_SITE_CONFIGURATION = 'SET_SITE_CONFIGURATION'
export const SET_SITE_CONFIGS = 'SET_SITE_CONFIGS'

export const AUTHENTICATE_USER_REQUEST = 'AUTHENTICATE_USER_REQUEST'
export const AUTHENTICATE_USER_SUCCESS = 'AUTHENTICATE_USER_SUCCESS'
export const AUTHENTICATE_USER_FAILURE = 'AUTHENTICATE_USER_FAILURE'
export const UPDATE_AUTH_CURRENT_USER = 'UPDATE_AUTH_CURRENT_USER'

// DASHBOARD
export const DASHBOARD_REQUEST = 'DASHBOARD_REQUEST'
export const DASHBOARD_SUCCESS = 'DASHBOARD_SUCCESS'
export const DASHBOARD_FAILURE = 'DASHBOARD_FAILURE'
